module.exports = __webpack_public_path__ + "static/media/NotOpen.77573f62.svg";